import { Component, Input } from '@angular/core';
import { DecidoEvaluation, DecidoEvaluationService } from 'src/app/core/decido-evaluation.service';
import { ErrorService } from 'src/app/core/error.service';
import { Order } from 'src/app/core/orders.service';

@Component({
  selector: 'app-order-details-decido-bd5',
  templateUrl: './order-details-decido-bd5.component.html',
  styleUrls: ['./order-details-decido-bd5.component.scss'],
})
export class OrderDetailsDecidoBd5Component {
  @Input() order?: Order;

  is_read_running = false;
  decido_evaluation?: DecidoEvaluation;

  constructor(private decido_evaluation_service: DecidoEvaluationService, private error_service: ErrorService) {}

  ngOnInit(): void {
    const bd5_id = this.order?.bd5_evaluation_id;
    const buyer_id = this.order?.buyer_id;
    if (bd5_id && buyer_id) this.readDecidoEvaluation(bd5_id, buyer_id);
  }

  readDecidoEvaluation(decido_evaluation_id: string, buyer_id: string): void {
    this.is_read_running = true;
    this.decido_evaluation_service.read(decido_evaluation_id, buyer_id).subscribe({
      next: response => {
        this.decido_evaluation = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.decido_evaluation = undefined;
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  getEvaluationClass(result?: string): string {
    if (result && result.toUpperCase() == 'DEL-POS') {
      return 'sp-color__green';
    }
    return 'sp-color__red';
  }
}
